
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, Brain } from 'lucide-react';

const AdThinkingSection: React.FC = () => {
  return (
    <section className="py-20 px-6 md:px-10 bg-white dark:bg-gray-900">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-8 animate-fade-in-up opacity-0" style={{animationDelay: "200ms", animationFillMode: "forwards"}}>
          <div className="inline-flex mb-6">
            <Brain className="h-12 w-12 text-heading-accent animate-float" />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6 animate-fade-in-up opacity-0" style={{animationDelay: "300ms", animationFillMode: "forwards"}}>
            Still Thinking It Over? That's Normal.
          </h2>
          
          <div className="prose prose-lg dark:prose-invert mx-auto animate-fade-in-up opacity-0" style={{animationDelay: "400ms", animationFillMode: "forwards"}}>
            <p className="text-lg text-gray-700 dark:text-gray-300">
              You're not alone if your brain is saying things like:
            </p>
          </div>
        </div>
        
        <div className="max-w-2xl mx-auto mb-10">
          <div className="space-y-4">
            {[
              "I need to do more research.",
              "I'm not ready yet.",
              "What if it's a waste of time?"
            ].map((quote, index) => (
              <div 
                key={index} 
                className="bg-gray-100 dark:bg-gray-800 px-6 py-4 rounded-lg border-l-4 border-heading-accent animate-fade-in-up opacity-0" 
                style={{animationDelay: `${500 + (index * 150)}ms`, animationFillMode: "forwards"}}
              >
                <p className="text-gray-800 dark:text-gray-200 font-medium">"{quote}"</p>
              </div>
            ))}
          </div>
        </div>
        
        <div className="text-center mb-10 animate-fade-in-up opacity-0" style={{animationDelay: "900ms", animationFillMode: "forwards"}}>
          <p className="text-xl font-medium text-gray-900 dark:text-gray-100 mb-2">
            Truth is: most business owners don't fail because they're unmotivated.
          </p>
          <p className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-6">
            They fail because they hesitate while others move.
          </p>
          
          <div className="max-w-2xl mx-auto">
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-8">
              We don't ask for commitment. Just a conversation.
              <br />We'll show you where AI makes sense—and where it doesn't.
            </p>
          </div>
        </div>
        
        <div className="text-center animate-fade-in-up opacity-0" style={{animationDelay: "1000ms", animationFillMode: "forwards"}}>
          <Button 
            size="lg" 
            className="bg-heading-accent hover:bg-heading-accent/90 text-white group btn-hover-effect"
            onClick={() => {
              const formSection = document.getElementById("lead-form");
              formSection?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Let's Talk – No Pressure
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AdThinkingSection;
